import { useRef, useState } from "react"
import { useHistory } from "react-router-dom";
import classNames from "classnames";

import { useFirebase } from "@meddbriefer/mdb-firebase";
import { saveDocument, verifyDocNameUniqueness } from "@meddbriefer/scenario-data"

import { deepCopy } from "./formUtils";

export default function SetScenarioNameForm({ scenario, isTemplate }) {
    const {db} = useFirebase()
    const [nameIsUnique, setNameIsUnique] = useState(true)
    const [scenarioName, setScenarioName] = useState(null)
    const formEL = useRef(null)
    const history = useHistory();

    const changeHandler = async (event) => {
        console.log(event.target.name, event.target.value)
        const isUnique = await verifyDocNameUniqueness(db, "scenarios", event.target.value, "name", "V2")
        console.log(isUnique)
        setNameIsUnique(isUnique)
        if (isUnique) {
            setScenarioName(event.target.value)
        } else {
            setScenarioName(null)
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (!scenarioName) {
            console.log("scenarioName is null")
            return
        }
        // save pre-existing scenario data structure with new name and id
        const newScenObj = deepCopy(scenario)
        newScenObj.name = scenarioName
        // I *believe* this doesn't return a promise, so no need for "await"
        const newDocRef = db.collection("scenarios").doc()
        newScenObj.id = newDocRef.id
        await saveDocument(db, "scenarios", newScenObj)
        // redirect to edit route for this new scenario
        history.push(`/scenario/${newScenObj.id}`)
    }

    return (
        <div className="scenario-form-wrapper">
            <form className="scenario-form" ref={formEL} onSubmit={handleSubmit}>
                <div className="info-wrapper">
                    {isTemplate
                        ? <h3>Please provide a new name for your cloned scenario</h3>
                        : <h3>Please give your new scenario a name</h3>
                    }

                    <input type="text" name="scenario-name" required autoComplete="off" onChange={changeHandler} />
                    <br/>
                    <span className={classNames("error", {"hidden": nameIsUnique})}>Scenario name is not unique</span>
                    <br/>
                    <button type="submit">Submit</button>
                </div>
            </form>
        </div>

    )
}
